module.exports = __webpack_public_path__ + "static/img/yyxb1.8a03335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yyxb1.png
// module id = CRvu
// module chunks = 1